/**
 * Moast 轮播布局定制
 * - 活动页/首页：PC 一屏约 5.3 张 / M 一屏约 1.7 张（左对齐：第 1 张完整，末张露出约 30%/70%）
 * - 首屏从第 1 个产品开始，不居中
 * - 活动页/首页：隐藏左右箭头，改为圆点引导条；标题 M 居左 / PC 居中；背景由 Apps section 配置
 * - 详情页（template-product 且非 activity-product-detail）：PC 一屏约 3.2 张（9:16 竖版）/ M 一屏约 2.2 张；大写标题、浅黄背景、M 端滑动分页条 / PC 端左右箭头（首尾置灰）；末位右对齐
 * - 左右间距：M 加在 :host（16px）；PC width:85% max-width:1400px
 *   （勿给 Embla viewport/container 加 padding，否则会出现 translate3d(-16px)）
 */
(function () {
  var PC_VISIBLE = 5.3;
  var M_VISIBLE = 1.7;
  var PDP_PC_VISIBLE = 3.2;
  var PDP_M_VISIBLE = 2.2;
  var PDP_SPACING = 8;
  var MOBILE_BREAKPOINT = 700;
  var DEFAULT_SPACING = 16;
  var MOBILE_SIDE_PAD = 16;
  var DESKTOP_SIDE_PAD = 0;
  var SHADOW_STYLE_ID = "moast-theme-layout-style";
  var HOST_STYLE_ID = "moast-theme-host-style";
  var CSS_VERSION = "layout-v35-pdp-slide-pagination";
  var PDP_ARROW_SIZE = 5;
  var PDP_DESKTOP_SIDE_PAD = 8;
  var PDP_LIGHT_ARROWS_CLASS = "moast-pdp-light-arrows";
  var PDP_LIGHT_ARROW_BTN = "moast-pdp-light-arrow";
  var PDP_LIGHT_ARROW_NEXT =
  '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">' +
  '<path d="M7.99934 20.7498C8.19841 20.7508 8.38946 20.6715 8.52934 20.5298L16.5293 12.5298C16.8218 12.237 16.8218 11.7627 16.5293 11.4698L8.52934 3.46985C8.23383 3.19449 7.77333 3.20261 7.48772 3.48823C7.20211 3.77384 7.19398 4.23434 7.46934 4.52985L14.9393 11.9998L7.46934 19.4698C7.17689 19.7627 7.17689 20.237 7.46934 20.5298C7.60922 20.6715 7.80027 20.7508 7.99934 20.7498Z" fill="black"/>' +
  '</svg>';
  var PDP_LIGHT_ARROW_PREV =
  '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">' +
  '<path d="M15.9993 20.7498C15.8003 20.7508 15.6092 20.6715 15.4693 20.5298L7.46934 12.5298C7.17689 12.237 7.17689 11.7627 7.46934 11.4698L15.4693 3.46985C15.7648 3.19449 16.2253 3.20261 16.511 3.48823C16.7966 3.77384 16.8047 4.23434 16.5293 4.52985L9.05934 11.9998L16.5293 19.4698C16.8218 19.7627 16.8218 20.237 16.5293 20.5298C16.3895 20.6715 16.1984 20.7508 15.9993 20.7498Z" fill="black"/>' +
  '</svg>';
    // '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    // '<path d="M15 6L9 12L15 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  // var PDP_LIGHT_ARROW_NEXT =
  //   '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
  //   '<path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var GUIDE_CLASS = "moast-theme-guide";
  var GUIDE_LINE_CLASS = "moast-pdp-guide-line";
  var PDP_SECTION_BG = "#FFFBEB";
  var layoutModeCache = null;
  var MOAST_PLAY_STYLE_ID = "moast-theme-play-style";
  var MOAST_PLAY_BUTTON_SVG_KEY = "play-v4";
  var MOAST_PLAY_BUTTON_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 12 12" fill="#ffffff" data-moast-solid="1" aria-hidden="true">' +
  '<path d="M10.7043 4.67629C11.7652 5.25323 11.7652 6.74677 10.7043 7.32371L4.29831 10.8073C3.26718 11.368 2 10.6382 2 9.48355L2 2.51645C2 1.36184 3.26718 0.632012 4.29831 1.19274L10.7043 4.67629Z" fill="#ffffff" stroke="none" style="fill:#ffffff;stroke:none"/>' +
  "</svg>";
  // var MOAST_PLAY_BUTTON_SVG =
  //   '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 12 12" fill="#ffffff" data-moast-solid="1" aria-hidden="true">' +
  //   '<path d="M10.7043 4.67629C11.7652 5.25323 11.7652 6.74677 10.7043 7.32371L4.29831 10.8073C3.26718 11.368 2 10.6382 2 9.48355L2 2.51645C2 1.36184 3.26718 0.632012 4.29831 1.19274L10.7043 4.67629Z" fill="#ffffff" stroke="none" style="fill:#ffffff;stroke:none"/>' +
  //   "</svg>";
  var MOAST_PLAY_SHADOW_CSS =
    ".pause-button-container {" +
    "  display: flex !important;" +
    "  align-items: center !important;" +
    "  justify-content: center !important;" +
    "}" +
    ".pause-button {" +
    "  display: inline-flex !important;" +
    "  align-items: center !important;" +
    "  justify-content: center !important;" +
    "  padding: 14px !important;" +
    "  border: 0 !important;" +
    "  border-radius: 50% !important;" +
    "  background: rgba(0, 0, 0, 0.75) !important;" +
    "  box-sizing: border-box !important;" +
    "  width: auto !important;" +
    "  height: auto !important;" +
    "  min-width: 0 !important;" +
    "  min-height: 0 !important;" +
    "  line-height: 0 !important;" +
    "  box-shadow: none !important;" +
    "}" +
    ".pause-button svg {" +
    "  width: 16px !important;" +
    "  height: 16px !important;" +
    "  display: block !important;" +
    "  flex-shrink: 0 !important;" +
    "  fill: #ffffff !important;" +
    "}" +
    ".pause-button svg path," +
    ".pause-button svg *" +
    "{" +
    "  fill: #ffffff !important;" +
    "  stroke: none !important;" +
    "  stroke-width: 0 !important;" +
    "}";
  /** 产品条背景（覆盖 Moast dark 主题默认 rgba(0,0,0,.75)） */
  var PRODUCT_CARD_BG = "transparent";
  var PRODUCT_CARD_TEXT = "#011701";

  var resizeTimer = null;
  var boundCarousels = new WeakSet();
  var patching = false;
  var mutationTimer = null;

  function getCarousel() {
    return document.querySelector("moast-carousel");
  }

  function getLayoutMode() {
    if (layoutModeCache) return layoutModeCache;
    if (document.querySelector(".activity-product-detail")) {
      layoutModeCache = "activity";
    } else if (document.body.classList.contains("template-product")) {
      layoutModeCache = "pdp";
    } else {
      layoutModeCache = "activity";
    }
    return layoutModeCache;
  }

  function isPdpLayout() {
    return getLayoutMode() === "pdp";
  }

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function getVisibleCount() {
    if (isPdpLayout()) {
      return isMobile() ? PDP_M_VISIBLE : PDP_PC_VISIBLE;
    }
    return isMobile() ? M_VISIBLE : PC_VISIBLE;
  }

  /** 整数一屏（如 PDP PC 4 张）用 visible-1 个间距；带露出的小数一屏用 floor(visible) */
  function getGapCount(visible) {
    if (visible % 1 === 0) return Math.max(0, visible - 1);
    return Math.floor(visible);
  }

  function getSidePad() {
    if (isPdpLayout() && !isMobile()) return PDP_DESKTOP_SIDE_PAD;
    return isMobile() ? MOBILE_SIDE_PAD : DESKTOP_SIDE_PAD;
  }

  function parseCssPx(value, fallback) {
    var n = parseFloat(value);
    return isNaN(n) ? fallback : n;
  }

  function getSpacing(carousel) {
    var fallback = isPdpLayout() ? PDP_SPACING : DEFAULT_SPACING;
    return parseCssPx(
      getComputedStyle(carousel).getPropertyValue("--moast-slide-spacing"),
      fallback
    );
  }

  function getHostCssShared() {
    return (
      "moast-carousel {" +
      "  display: block !important;" +
      "  box-sizing: border-box !important;" +
      "  width: 100% !important;" +
      "  max-width: none !important;" +
      "  margin-left: 0 !important;" +
      "  margin-right: 0 !important;" +
      "  padding-left: " +
      MOBILE_SIDE_PAD +
      "px !important;" +
      "  padding-right: " +
      MOBILE_SIDE_PAD +
      "px !important;" +
      "  touch-action: pan-y pinch-zoom !important;" +
      "}" +
      "#shopify-block-AODg1dWtPNzU3aDNwS__moast_widget_ByFDy9," +
      ".shopify-app-block[id*=\"moast\"] {" +
      "  touch-action: pan-y pinch-zoom !important;" +
      "}" +
      "@media screen and (min-width: 701px) {" +
      "  moast-carousel {" +
      "    width: 85% !important;" +
      "    max-width: 1400px !important;" +
      "    margin-left: auto !important;" +
      "    margin-right: auto !important;" +
      "    padding-left: 0 !important;" +
      "    padding-right: 0 !important;" +
      "  }" +
      "}"
    );
  }

  function getHostCss() {
    if (isPdpLayout()) {
      return (
        getHostCssShared() +
        "body.template-product .shopify-app-block[id*=\"moast\"] {" +
        "  background: " +
        PDP_SECTION_BG +
        " !important;" +
        "  padding-top: 0 !important;" +
        "  padding-bottom: 0 !important;" +
        "}" +
        "@media screen and (min-width: 701px) {" +
        "  body.template-product .shopify-app-block[id*=\"moast\"] {" +
        "    position: relative !important;" +
        "    padding-top: 0 !important;" +
        "    padding-bottom: 0 !important;" +
        "    overflow: visible !important;" +
        "  }" +
        "  body.template-product ." +
        PDP_LIGHT_ARROWS_CLASS +
        " {" +
        "    position: absolute !important;" +
        "    left: 0 !important;" +
        "    right: 0 !important;" +
        "    top: 0;" +
        "    height: 0 !important;" +
        "    margin: 0 !important;" +
        "    padding: 0 !important;" +
        "    pointer-events: none !important;" +
        "    z-index: 5 !important;" +
        "    overflow: visible !important;" +
        "  }" +
        "  body.template-product ." +
        PDP_LIGHT_ARROW_BTN +
        " {" +
        "    position: absolute !important;" +
        "    top: 0 !important;" +
        "    display: inline-flex !important;" +
        "    align-items: center !important;" +
        "    justify-content: center !important;" +
        "    width: " +
        PDP_ARROW_SIZE +
        "rem !important;" +
        "    height: " +
        PDP_ARROW_SIZE +
        "rem !important;" +
        "    margin: 0 !important;" +
        "    padding: 0 !important;" +
        "    border: 1px solid rgba(1, 23, 1, 0.12) !important;" +
        "    border-radius: 50% !important;" +
        "    background: #ffffff !important;" +
        "    color: #011701 !important;" +
        "    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;" +
        "    cursor: pointer !important;" +
        "    pointer-events: auto !important;" +
        "    transition: opacity 0.2s ease, border-color 0.2s ease !important;" +
        "    appearance: none !important;" +
        "  }" +
        "  body.template-product ." +
        PDP_LIGHT_ARROW_BTN +
        "--prev {" +
        "    left: 0 !important;" +
        "    transform: translate(-50%, -50%) !important;" +
        "  }" +
        "  body.template-product ." +
        PDP_LIGHT_ARROW_BTN +
        "--next {" +
        "    right: 0 !important;" +
        "    transform: translate(50%, -50%) !important;" +
        "  }" +
        "  body.template-product ." +
        PDP_LIGHT_ARROW_BTN +
        ".is-disabled {" +
        "    opacity: 0.35 !important;" +
        "    border-color: rgba(1, 23, 1, 0.08) !important;" +
        "    color: rgba(1, 23, 1, 0.35) !important;" +
        "    cursor: default !important;" +
        "    pointer-events: none !important;" +
        "    box-shadow: none !important;" +
        "  }" +
        "  body.template-product .product_cen_detail:has(.shopify-app-block[id*=\"moast\"]) {" +
        "    overflow: visible !important;" +
        "  }" +
        "  body.template-product moast-carousel {" +
        "    width: 100% !important;" +
        "    max-width: none !important;" +
        "    margin-left: 0 !important;" +
        "    margin-right: 0 !important;" +
        "    padding-left: " +
        PDP_DESKTOP_SIDE_PAD +
        "px !important;" +
        "    padding-right: " +
        PDP_DESKTOP_SIDE_PAD +
        "px !important;" +
        "    overflow: visible !important;" +
        "  }" +
        "}"
      );
    }

    return (
      getHostCssShared() +
      "#shopify-block-AODg1dWtPNzU3aDNwS__moast_widget_ByFDy9," +
      ".shopify-app-block[id*=\"moast\"] {" +
      "  background: var(--moast-theme-section-bg-mobile, transparent) !important;" +
      "}" +
      "@media screen and (min-width: 701px) {" +
      "  #shopify-block-AODg1dWtPNzU3aDNwS__moast_widget_ByFDy9," +
      "  .shopify-app-block[id*=\"moast\"] {" +
      "    background: var(--moast-theme-section-bg-desktop, transparent) !important;" +
      "  }" +
      "}"
    );
  }

  function injectHostCss() {
    var style = document.getElementById(HOST_STYLE_ID);
    if (!style) {
      style = document.createElement("style");
      style.id = HOST_STYLE_ID;
      document.head.appendChild(style);
    }
    if (style.dataset.moastCssVer !== CSS_VERSION) {
      style.dataset.moastCssVer = CSS_VERSION;
      style.textContent = getHostCss();
    }
  }

  function getCarouselCssActivity() {
    return (
      /* :host：M 端左右 16px（不在 Embla viewport 上加 padding，避免 translate -16px） */
      ":host {" +
      "  display: block !important;" +
      "  box-sizing: border-box !important;" +
      "  width: 100% !important;" +
      "  max-width: none !important;" +
      "  margin-left: 0 !important;" +
      "  margin-right: 0 !important;" +
      "  padding-left: " +
      MOBILE_SIDE_PAD +
      "px !important;" +
      "  padding-right: " +
      MOBILE_SIDE_PAD +
      "px !important;" +
      "}" +
      "@media screen and (min-width: 701px) {" +
      "  :host {" +
      "    width: 85% !important;" +
      "    max-width: 1400px !important;" +
      "    margin-left: auto !important;" +
      "    margin-right: auto !important;" +
      "    padding-left: 0 !important;" +
      "    padding-right: 0 !important;" +
      "  }" +
      "}" +
      /* .carousel-wrapper 始终透明：宽度/间距保持；背景改挂外层 shopify-block */
      ".carousel-wrapper {" +
      "  background: transparent !important;" +
      "  background-color: transparent !important;" +
      "  background-image: none !important;" +
      "}" +
      /* 标题：M 居左 / PC 居中（左右间距由 :host padding 提供，标题不再加水平 padding） */
      ".carousel-header {" +
      "  font-family: \"Newsreader\", Times, serif !important;" +
      "  font-weight: 400 !important;" +
      "  font-size: 26px !important;" +
      "  line-height: 1.2 !important;" +
      "  text-align: left !important;" +
      "  color: #011701 !important;" +
      "  padding: 0 !important;" +
      "  margin: 0 0 16px !important;" +
      "  box-sizing: border-box !important;" +
      "}" +
      "@media screen and (min-width: 701px) {" +
      "  .carousel-header {" +
      "    font-size: 48px !important;" +
      "    text-align: center !important;" +
      "    margin: 0 0 24px !important;" +
      "  }" +
      "}" +
      /* Embla viewport/container 不加左右 padding，避免出现 translate3d(-16px) */
      ".carousel--cards," +
      ".carousel.carousel--cards," +
      "#carousel-slides.slides," +
      "#carousel-slides," +
      ".slides {" +
      "  padding-left: 0 !important;" +
      "  padding-right: 0 !important;" +
      "  padding-inline: 0 !important;" +
      "}" +
      /*
       * iOS Safari：容器允许纵向 pan，否则手指在轮播上时页面上下滑会被 Embla 吃掉；
       * 勿用 scroll-snap（与 Embla transform 拖拽冲突）；
       * 不要给 .slide * 全局 touch-action（会干扰视频/按钮手势）。
       */
      ":host," +
      ".carousel-wrapper," +
      ".carousel," +
      ".carousel--cards," +
      "#carousel-slides," +
      ".slides {" +
      "  touch-action: pan-y pinch-zoom !important;" +
      "}" +
      /* 左对齐间距：间距只加在右侧，便于算 5.3 / 1.7 */
      ".slide {" +
      "  max-width: var(--moast-theme-slide-size, var(--moast-slide-size, 250px)) !important;" +
      "  width: var(--moast-theme-slide-size, var(--moast-slide-size, 250px)) !important;" +
      "  flex: 0 0 var(--moast-theme-slide-size, var(--moast-slide-size, 250px)) !important;" +
      "  margin-left: 0 !important;" +
      "  margin-right: var(--moast-slide-spacing, 16px) !important;" +
      "  scroll-snap-align: none !important;" +
      "  scroll-snap-stop: normal !important;" +
      "}" +
      "@media screen and (max-width: 700px) {" +
      "  .slide {" +
      "    max-width: var(--moast-theme-slide-size, var(--moast-slide-size, 250px)) !important;" +
      "    width: var(--moast-theme-slide-size, var(--moast-slide-size, 250px)) !important;" +
      "    flex: 0 0 var(--moast-theme-slide-size, var(--moast-slide-size, 250px)) !important;" +
      "    min-width: 0 !important;" +
      "  }" +
      "}" +
      /* 隐藏原生左右箭头 */
      ".pagination .carousel__prev," +
      ".pagination .carousel__next," +
      "button.carousel__prev," +
      "button.carousel__next {" +
      "  display: none !important;" +
      "  visibility: hidden !important;" +
      "  pointer-events: none !important;" +
      "  width: 0 !important;" +
      "  height: 0 !important;" +
      "  margin: 0 !important;" +
      "  padding: 0 !important;" +
      "  overflow: hidden !important;" +
      "}" +
      ".pagination {" +
      "  display: flex !important;" +
      "  justify-content: center !important;" +
      "  align-items: center !important;" +
      "  margin-top: 20px !important;" +
      "  padding: 0 !important;" +
      "  gap: 0 !important;" +
      "  min-height: 12px !important;" +
      "}" +
      "." +
      GUIDE_CLASS +
      " {" +
      "  display: flex !important;" +
      "  align-items: center !important;" +
      "  justify-content: center !important;" +
      "  gap: 8px !important;" +
      "  margin: 0 !important;" +
      "  padding: 0 !important;" +
      "  list-style: none !important;" +
      "}" +
      "." +
      GUIDE_CLASS +
      " button {" +
      "  appearance: none;" +
      "  border: 0;" +
      "  padding: 0;" +
      "  margin: 0;" +
      "  cursor: pointer;" +
      "  background: rgba(1, 23, 1, 0.2);" +
      "  width: 6px;" +
      "  height: 6px;" +
      "  border-radius: 50%;" +
      "  transition: width 0.2s ease, border-radius 0.2s ease, background 0.2s ease;" +
      "}" +
      "." +
      GUIDE_CLASS +
      " button.is-active {" +
      "  width: 24px;" +
      "  height: 4px;" +
      "  border-radius: 2px;" +
      "  background: #011701;" +
      "}"
    );
  }

  function getCarouselCssPdp() {
    return (
      getCarouselCssActivity()
        .replace(
          /* 详情页标题：大写 + 字号 */
          ".carousel-header {" +
            "  font-family: \"Newsreader\", Times, serif !important;" +
            "  font-weight: 400 !important;" +
            "  font-size: 26px !important;" +
            "  line-height: 1.2 !important;" +
            "  text-align: left !important;" +
            "  color: #011701 !important;" +
            "  padding: 0 !important;" +
            "  margin: 0 0 16px !important;" +
            "  box-sizing: border-box !important;" +
            "}" +
            "@media screen and (min-width: 701px) {" +
            "  .carousel-header {" +
            "    font-size: 48px !important;" +
            "    text-align: center !important;" +
            "    margin: 0 0 24px !important;" +
            "  }" +
            "}",
          ".carousel-header {" +
            "  font-family: \"Newsreader\", Times, serif !important;" +
            "  font-weight: 400 !important;" +
            "  font-size: 18px !important;" +
            "  line-height: 1.25 !important;" +
            "  letter-spacing: 0.02em !important;" +
            "  text-transform: uppercase !important;" +
            "  text-align: left !important;" +
            "  color: #101423 !important;" +
            "  padding: 0 !important;" +
            "  margin: 0 0 16px !important;" +
            "  box-sizing: border-box !important;" +
            "}" +
            "@media screen and (min-width: 701px) {" +
            "  .carousel-header {" +
            "    font-size: 18px !important;" +
            "    text-align: left !important;" +
            "    margin: 0 0 16px !important;" +
            "  }" +
            "}"
        )
        .replace(
          /* 详情页 PC：展示左右箭头 */
          ".pagination .carousel__prev," +
            ".pagination .carousel__next," +
            "button.carousel__prev," +
            "button.carousel__next {" +
            "  display: none !important;" +
            "  visibility: hidden !important;" +
            "  pointer-events: none !important;" +
            "  width: 0 !important;" +
            "  height: 0 !important;" +
            "  margin: 0 !important;" +
            "  padding: 0 !important;" +
            "  overflow: hidden !important;" +
            "}",
          ".pagination .carousel__prev," +
            ".pagination .carousel__next," +
            "button.carousel__prev," +
            "button.carousel__next {" +
            "  appearance: none;" +
            "  display: none;" +
            "  visibility: hidden;" +
            "  pointer-events: none;" +
            "  width: 0;" +
            "  height: 0;" +
            "  margin: 0;" +
            "  padding: 0;" +
            "  overflow: hidden;" +
            "}"
        ) +
      ".carousel-wrapper {" +
      "  position: relative !important;" +
      "  padding-top: var(--moast-padding-top, 0) !important;" +
      "  padding-bottom: var(--moast-padding-bottom, 0) !important;" +
      "  overflow: visible !important;" +
      "}" +
      "@media screen and (min-width: 701px) {" +
      "  :host {" +
      "    width: 100% !important;" +
      "    max-width: none !important;" +
      "    margin-left: 0 !important;" +
      "    margin-right: 0 !important;" +
      "    padding-left: " +
      PDP_DESKTOP_SIDE_PAD +
      "px !important;" +
      "    padding-right: " +
      PDP_DESKTOP_SIDE_PAD +
      "px !important;" +
      "    overflow: visible !important;" +
      "  }" +
      "  .pagination .carousel__prev," +
      "  .pagination .carousel__next," +
      "  button.carousel__prev," +
      "  button.carousel__next {" +
      "    display: none !important;" +
      "    visibility: hidden !important;" +
      "    pointer-events: none !important;" +
      "  }" +
      "  ." +
      GUIDE_CLASS +
      "," +
      "  ." +
      GUIDE_LINE_CLASS +
      " {" +
      "    display: none !important;" +
      "  }" +
      "}" +
      "@media screen and (max-width: 700px) {" +
      "  .pagination {" +
      "    position: static !important;" +
      "    transform: none !important;" +
      "    margin-top: 12px !important;" +
      "    padding: 0 !important;" +
      "    pointer-events: auto !important;" +
      "  }" +
      "  .pagination .carousel__prev," +
      "  .pagination .carousel__next," +
      "  button.carousel__prev," +
      "  button.carousel__next {" +
      "    display: none !important;" +
      "    visibility: hidden !important;" +
      "    pointer-events: none !important;" +
      "  }" +
      "  .pagination > *:not(." +
      GUIDE_LINE_CLASS +
      ") {" +
      "    display: none !important;" +
      "  }" +
      "  ." +
      GUIDE_CLASS +
      " {" +
      "    display: none !important;" +
      "  }" +
      "  ." +
      GUIDE_LINE_CLASS +
      " {" +
      "    display: block !important;" +
      "    width: 100% !important;" +
      "    max-width: 100% !important;" +
      "    margin: 0 !important;" +
      "    padding: 0 !important;" +
      "  }" +
      "  ." +
      GUIDE_LINE_CLASS +
      "__track {" +
      "  display: block !important;" +
      "  position: relative !important;" +
      "  width: 100% !important;" +
      "  height: 2px !important;" +
      "  border-radius: 999px !important;" +
      "  background: rgba(1, 23, 1, 0.12) !important;" +
      "  overflow: hidden !important;" +
      "}" +
      "  ." +
      GUIDE_LINE_CLASS +
      "__fill {" +
      "  display: block !important;" +
      "  position: absolute !important;" +
      "  top: 0 !important;" +
      "  left: 0 !important;" +
      "  height: 100% !important;" +
      "  width: 0;" +
      "  border-radius: inherit !important;" +
      "  background: #011701 !important;" +
      "  transition: transform 0.2s ease !important;" +
      "  will-change: transform;" +
      "}" +
      "}" +
      /* 详情页：视频缩略图固定 9:16，与设计稿一致 */
      ".slide .card," +
      ".slide moast-card," +
      ".slide a.card," +
      ".slide button.card {" +
      "  display: block !important;" +
      "  width: 100% !important;" +
      "  height: auto !important;" +
      "  overflow: hidden !important;" +
      "  border-radius: 4px !important;" +
      "}" +
      ".slide .card__media," +
      ".slide .media," +
      ".slide moast-media," +
      ".slide moast-video," +
      ".slide video," +
      ".slide img," +
      ".slide .poster," +
      ".slide .thumbnail {" +
      "  aspect-ratio: 9 / 16 !important;" +
      "  width: 100% !important;" +
      "  height: auto !important;" +
      "  object-fit: cover !important;" +
      "  display: block !important;" +
      "}" +
      /* M 端露出下一张时，末位需额外 scroll padding 才能右对齐 */
      "#carousel-slides::after," +
      ".slides::after {" +
      "  content: \"\" !important;" +
      "  display: block !important;" +
      "  flex: 0 0 var(--moast-theme-end-pad, 0px) !important;" +
      "  width: var(--moast-theme-end-pad, 0px) !important;" +
      "  min-width: var(--moast-theme-end-pad, 0px) !important;" +
      "  height: 1px !important;" +
      "  pointer-events: none !important;" +
      "}"
    );
  }

  function getCarouselCss() {
    if (isPdpLayout()) return getCarouselCssPdp();
    return getCarouselCssActivity();
  }

  /** 深度收集 moast-play（可能嵌在 moast-media / moast-video 的 shadow 里） */
  function collectMoastPlayNodes(root, list, depth) {
    if (!root || (depth || 0) > 6) return list;
    var nodes = root.querySelectorAll ? root.querySelectorAll("moast-play") : [];
    for (var i = 0; i < nodes.length; i++) {
      if (list.indexOf(nodes[i]) === -1) list.push(nodes[i]);
    }
    // 只继续挖带 shadow 的自定义元素，避免 querySelectorAll('*') 扫爆
    var hosts = root.querySelectorAll
      ? root.querySelectorAll("moast-media, moast-video, moast-slide, moast-card, moast-product")
      : [];
    for (var j = 0; j < hosts.length; j++) {
      if (hosts[j].shadowRoot) {
        collectMoastPlayNodes(hosts[j].shadowRoot, list, (depth || 0) + 1);
      }
    }
    return list;
  }

  function injectMoastPlayShadowCss(playRoot) {
    if (!playRoot) return;
    var style = playRoot.getElementById(MOAST_PLAY_STYLE_ID);
    if (!style) {
      style = document.createElement("style");
      style.id = MOAST_PLAY_STYLE_ID;
      playRoot.appendChild(style);
    }
    if (style.dataset.moastPlayCssVer !== MOAST_PLAY_BUTTON_SVG_KEY) {
      style.dataset.moastPlayCssVer = MOAST_PLAY_BUTTON_SVG_KEY;
      style.textContent = MOAST_PLAY_SHADOW_CSS;
    }
  }

  /** 只改 moast-play shadow：空心三角 → 实心 14px SVG */
  function isSolidMoastPlaySvg(svg) {
    if (!svg) return false;
    if (svg.getAttribute("data-moast-solid") === "1") return true;
    var path = svg.querySelector("path");
    if (!path) return false;
    var d = path.getAttribute("d") || "";
    return d.indexOf("10.7043") >= 0;
  }

  function patchMoastPlayNode(playEl) {
    if (!playEl || playEl.__moastPlayPatching) return;
    var playRoot = playEl.shadowRoot;
    if (!playRoot) return;

    injectMoastPlayShadowCss(playRoot);

    var btn = playRoot.querySelector(".pause-button, button.pause-button");
    if (!btn) return;

    var svg = btn.querySelector("svg");
    if (isSolidMoastPlaySvg(svg) && btn.dataset.moastPlayIconKey === MOAST_PLAY_BUTTON_SVG_KEY) {
      return;
    }

    playEl.__moastPlayPatching = true;
    btn.dataset.moastPlayIconKey = MOAST_PLAY_BUTTON_SVG_KEY;
    btn.innerHTML = MOAST_PLAY_BUTTON_SVG;
    requestAnimationFrame(function () {
      playEl.__moastPlayPatching = false;
    });

    if (!playEl.__moastPlayObserved) {
      playEl.__moastPlayObserved = true;
      var playTimer = null;
      new MutationObserver(function () {
        if (playEl.__moastPlayPatching) return;
        // 已换成实心图标后不再反复改 DOM，避免 iOS 触摸卡顿
        var btn = playRoot.querySelector(".pause-button, button.pause-button");
        var svg = btn && btn.querySelector("svg");
        if (
          isSolidMoastPlaySvg(svg) &&
          btn.dataset.moastPlayIconKey === MOAST_PLAY_BUTTON_SVG_KEY
        ) {
          return;
        }
        clearTimeout(playTimer);
        playTimer = setTimeout(function () {
          patchMoastPlayNode(playEl);
        }, 30);
      }).observe(playRoot, { childList: true, subtree: true });
    }
  }

  function patchPauseButtons(root) {
    if (!root) return;
    var plays = collectMoastPlayNodes(root, []);
    // 兼容：moast-play 也可能挂在 light DOM（carousel 外层）
    document.querySelectorAll("moast-play").forEach(function (el) {
      if (plays.indexOf(el) === -1) plays.push(el);
    });
    plays.forEach(patchMoastPlayNode);
  }

  function injectShadowCss(root) {
    if (!root) return;
    var style = root.getElementById(SHADOW_STYLE_ID);
    if (!style) {
      style = document.createElement("style");
      style.id = SHADOW_STYLE_ID;
      root.appendChild(style);
    }
    // 仅版本变化时写入，避免 MutationObserver 因反复改 textContent 死循环卡死页面
    if (style.dataset.moastCssVer !== CSS_VERSION) {
      style.dataset.moastCssVer = CSS_VERSION;
      style.textContent = getCarouselCss();
    }
  }

  /** 强制清除 .slides 左右 padding（仅在尚未清零时写入） */
  function clearSlidesPadding(root) {
    if (!root) return;
    root.querySelectorAll("#carousel-slides, .slides").forEach(function (el) {
      if (el.style.getPropertyValue("padding-left") !== "0") {
        el.style.setProperty("padding-left", "0", "important");
      }
      if (el.style.getPropertyValue("padding-right") !== "0") {
        el.style.setProperty("padding-right", "0", "important");
      }
      if (el.style.getPropertyValue("padding-inline") !== "0") {
        el.style.setProperty("padding-inline", "0", "important");
      }
    });
  }

  function isSelfManagedMutation(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var target = mutations[i].target;
      if (!target) continue;
      // 我们自己注入的 style / 引导条变更，不需要再触发 patch
      if (target.id === SHADOW_STYLE_ID) return true;
      if (
        target.nodeType === 1 &&
        target.classList &&
        (target.classList.contains(GUIDE_CLASS) ||
          target.classList.contains(GUIDE_LINE_CLASS) ||
          target.classList.contains(GUIDE_LINE_CLASS + "__track") ||
          target.classList.contains(GUIDE_LINE_CLASS + "__fill"))
      ) {
        return true;
      }
      if (
        target.parentElement &&
        (target.parentElement.id === SHADOW_STYLE_ID ||
          (target.parentElement.classList &&
            target.parentElement.classList.contains(GUIDE_CLASS)))
      ) {
        return true;
      }
    }
    return false;
  }

  /**
   * Moast 默认 alignment=center，会把首屏滚到中间；强制改为 left + Embla start。
   * 并覆写其 _applySlidesInViewAlignmentOffset，避免再次滚到中间。
   */
  function ensureLeftStart(carousel) {
    try {
      carousel.alignment = "left";
    } catch (err) {
      /* ignore */
    }
    carousel.setAttribute("alignment", "left");

    if (carousel._options) {
      carousel._options.align = "start";
      carousel._options.startIndex = 0;
    }

    if (!carousel.__moastAlignPatched) {
      carousel.__moastAlignPatched = true;
      carousel._applySlidesInViewAlignmentOffset = function () {
        var self = this;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (self._carousel && typeof self._carousel.scrollTo === "function") {
              // 仅在仍停在中间/非首位时才拉回，避免打断用户滑动
              if (!self.__moastUserInteracted) {
                self._carousel.scrollTo(0, true);
                normalizeStartTranslate(self);
              }
            }
          });
        });
      };
    }
  }

  function scrollToFirst(carousel, force) {
    var embla = carousel._carousel;
    if (!embla || typeof embla.scrollTo !== "function") return;
    if (!force && carousel.__moastUserInteracted) return;
    try {
      embla.scrollTo(0, true);
    } catch (err) {
      /* ignore */
    }
    normalizeStartTranslate(carousel);
  }

  /** 纠正 Embla 误算的 -16px 起始偏移，首屏应为 translate3d(0,0,0) */
  function normalizeStartTranslate(carousel) {
    if (!carousel || carousel.__moastUserInteracted) return;
    var root = carousel.shadowRoot;
    if (!root) return;

    var embla = carousel._carousel;
    if (embla && typeof embla.selectedScrollSnap === "function") {
      try {
        if (embla.selectedScrollSnap() !== 0) return;
      } catch (err) {
        /* ignore */
      }
    }

    var slides = root.querySelector("#carousel-slides, .slides");
    if (!slides) return;

    // 只在确实偏移时短暂纠正；立刻交还 transform 控制权给 Embla。
    // iOS 上长期挂着 inline transform 会导致左右拖不动、手势被卡住。
    var current = (slides.style && slides.style.transform) || "";
    var needsFix =
      /translate3d\(\s*-?\d/.test(current) &&
      !/translate3d\(\s*0(px)?\s*,\s*0(px)?\s*,\s*0(px)?\s*\)/.test(current);

    if (!needsFix) {
      // 清掉历史遗留的 inline transform，避免挡住 Embla
      if (slides.style.getPropertyValue("transform")) {
        slides.style.removeProperty("transform");
      }
      return;
    }

    slides.style.setProperty("transform", "translate3d(0px, 0px, 0px)");
    requestAnimationFrame(function () {
      if (!carousel.__moastUserInteracted && slides.isConnected) {
        slides.style.removeProperty("transform");
      }
    });
  }

  function markUserInteracted(carousel) {
    if (!carousel || carousel.__moastUserInteracted) return;
    carousel.__moastUserInteracted = true;
  }

  /** iOS：在 Embla pointerDown 之前就标记交互，避免对齐逻辑把滑动拉回 0 */
  function bindEarlyInteractionGuard(carousel) {
    if (!carousel || carousel.__moastTouchGuardBound) return;
    carousel.__moastTouchGuardBound = true;

    var mark = function () {
      markUserInteracted(carousel);
    };

    // capture + passive：只记账，绝不 preventDefault，避免锁死页面滚动
    carousel.addEventListener("touchstart", mark, { capture: true, passive: true });
    carousel.addEventListener("pointerdown", mark, { capture: true, passive: true });

    var root = carousel.shadowRoot;
    if (root) {
      root.addEventListener("touchstart", mark, { capture: true, passive: true });
      root.addEventListener("pointerdown", mark, { capture: true, passive: true });
    }
  }

  function updateSlideSize(carousel, forceReinit) {
    var rect = carousel.getBoundingClientRect();
    var sidePad = getSidePad();
    // M 端左右各 16px；PC 由 85%/1400 容器约束，sidePad=0
    var width = rect.width - sidePad * 2;
    if (width < 40) return false;

    var spacing = isPdpLayout() ? PDP_SPACING : getSpacing(carousel);
    var visible = getVisibleCount();
    var gaps = getGapCount(visible);
    var slideSize = (width - gaps * spacing) / visible;
    slideSize = Math.max(Math.round(slideSize * 100) / 100, 80);
    var nextValue = slideSize + "px";
    var prevValue = carousel.style.getPropertyValue("--moast-theme-slide-size");
    var endPad = 0;

    if (isPdpLayout() && visible % 1 !== 0) {
      endPad = Math.max(
        0,
        width -
          slideSize -
          Math.floor(visible) * (slideSize + spacing)
      );
    }

    carousel.style.setProperty("--moast-theme-side-pad", sidePad + "px");
    carousel.style.setProperty("--moast-theme-slide-size", nextValue);
    carousel.style.setProperty("--moast-slide-size", nextValue);
    carousel.style.setProperty("--moast-slide-spacing", spacing + "px");
    carousel.style.setProperty("--moast-theme-end-pad", endPad + "px");
    // 背景改由外层 shopify-block 控制；carousel 内始终透明
    carousel.style.setProperty("--moast-background-color", "transparent");
    if (isPdpLayout()) {
      carousel.style.setProperty("--moast-padding-top", "16px");
      carousel.style.setProperty(
        "--moast-padding-bottom",
        isMobile() ? "16px" : "32px"
      );
      if (!isMobile()) {
        var slideHeight916 =
          Math.round(slideSize * (16 / 9) * 100) / 100;
        var arrowTop = 16 + 23 + 16 + slideHeight916 / 2;
        carousel.style.setProperty(
          "--moast-theme-slide-height",
          slideHeight916 + "px"
        );
        carousel.style.setProperty("--moast-theme-arrow-top", arrowTop + "px");
      } else {
        carousel.style.removeProperty("--moast-theme-slide-height");
        carousel.style.removeProperty("--moast-theme-arrow-top");
      }
    }
    carousel.style.setProperty("--moast-card-background", PRODUCT_CARD_BG);
    carousel.style.setProperty("--moast-card-text", PRODUCT_CARD_TEXT);
    carousel.style.setProperty(
      "--moast-header-align",
      isPdpLayout() || isMobile() ? "left" : "center"
    );
    carousel.style.setProperty(
      "--moast-header-font-size",
      isPdpLayout()
        ? "18px"
        : isMobile()
          ? "24px"
          : "40px"
    );

    ensureLeftStart(carousel);

    // padding 策略变更后必须 reInit，否则 Embla 会残留 translate3d(-16px)
    var layoutKey = CSS_VERSION + ":" + nextValue + ":" + sidePad;
    var prevLayoutKey = carousel.dataset.moastLayoutKey || "";
    var needReinit = forceReinit || prevValue !== nextValue || prevLayoutKey !== layoutKey;
    carousel.dataset.moastLayoutKey = layoutKey;

    if (needReinit && carousel._carousel) {
      var embla = carousel._carousel;
      if (typeof embla.reInit === "function") {
        try {
          embla.reInit({
            align: "start",
            startIndex: 0,
            containScroll: isPdpLayout() ? "trimSnaps" : false,
          });
        } catch (err) {
          try {
            embla.reInit();
          } catch (err2) {
            /* ignore */
          }
        }
      }
      // reInit 后 Moast 仍可能异步做一次居中偏移，延迟拉回首位
      scrollToFirst(carousel, true);
      setTimeout(function () {
        if (!carousel.__moastUserInteracted) scrollToFirst(carousel, false);
      }, 50);
      setTimeout(function () {
        if (!carousel.__moastUserInteracted) scrollToFirst(carousel, false);
      }, 200);
    }

    return prevValue !== nextValue;
  }

  function getSnapCount(carousel) {
    var embla = carousel._carousel;
    if (!embla || typeof embla.scrollSnapList !== "function") return 0;
    return embla.scrollSnapList().length || 0;
  }

  function getSelectedIndex(carousel) {
    var embla = carousel._carousel;
    if (!embla || typeof embla.selectedScrollSnap !== "function") return 0;
    return embla.selectedScrollSnap() || 0;
  }

  function scrollToIndex(carousel, index) {
    var embla = carousel._carousel;
    if (!embla || typeof embla.scrollTo !== "function") return;
    markUserInteracted(carousel);
    embla.scrollTo(index);
  }

  function ensureGuideBar(carousel, root) {
    if (!root) return null;

    var pagination = root.querySelector(".pagination");
    var mount = pagination || root.querySelector(".carousel-wrapper") || root;

    var guide = mount.querySelector("." + GUIDE_CLASS);
    if (!guide) {
      guide = document.createElement("div");
      guide.className = GUIDE_CLASS;
      guide.setAttribute("role", "tablist");
      guide.setAttribute("aria-label", "Carousel pagination");
      if (pagination) {
        pagination.appendChild(guide);
      } else {
        mount.appendChild(guide);
      }
    }
    return guide;
  }

  function ensurePdpGuideLine(root) {
    if (!root) return null;
    var pagination = root.querySelector(".pagination");
    if (!pagination) return null;

    var line = pagination.querySelector("." + GUIDE_LINE_CLASS);
    if (!line) {
      line = document.createElement("div");
      line.className = GUIDE_LINE_CLASS;
      line.setAttribute("aria-hidden", "true");
      line.innerHTML =
        '<span class="' +
        GUIDE_LINE_CLASS +
        '__track"><span class="' +
        GUIDE_LINE_CLASS +
        '__fill"></span></span>';
      pagination.appendChild(line);
    }
    return line;
  }

  function updatePdpGuideLineFill(carousel, line) {
    if (!line) return;
    var fill = line.querySelector("." + GUIDE_LINE_CLASS + "__fill");
    if (!fill) return;

    var count = getSnapCount(carousel);
    if (count <= 1) {
      line.style.display = "none";
      fill.style.width = "100%";
      fill.style.transform = "translateX(0)";
      return;
    }

    line.style.display = "block";
    var segmentPct = 100 / count;
    fill.style.width = segmentPct + "%";

    var embla = carousel._carousel;
    var offset = 0;

    if (embla && typeof embla.scrollProgress === "function") {
      offset = embla.scrollProgress() * (count - 1);
    } else {
      offset = getSelectedIndex(carousel);
    }

    fill.style.transform = "translateX(" + offset * 100 + "%)";
  }

  function getMoastBlock(carousel) {
    if (!carousel) return null;
    return (
      carousel.closest('.shopify-app-block[id*="moast"]') ||
      carousel.parentElement
    );
  }

  function removePdpLightArrows(carousel) {
    var block = getMoastBlock(carousel);
    if (!block) return;
    var wrap = block.querySelector("." + PDP_LIGHT_ARROWS_CLASS);
    if (wrap) wrap.remove();
  }

  function ensurePdpLightArrows(carousel) {
    if (!isPdpLayout() || isMobile()) {
      removePdpLightArrows(carousel);
      return null;
    }

    var block = getMoastBlock(carousel);
    if (!block) return null;

    var wrap = block.querySelector("." + PDP_LIGHT_ARROWS_CLASS);
    if (!wrap) {
      wrap = document.createElement("div");
      wrap.className = PDP_LIGHT_ARROWS_CLASS;
      wrap.setAttribute("aria-hidden", "false");

      var prevBtn = document.createElement("button");
      prevBtn.type = "button";
      prevBtn.className = PDP_LIGHT_ARROW_BTN + " " + PDP_LIGHT_ARROW_BTN + "--prev";
      prevBtn.setAttribute("aria-label", "Previous slide");
      prevBtn.innerHTML = PDP_LIGHT_ARROW_PREV;

      var nextBtn = document.createElement("button");
      nextBtn.type = "button";
      nextBtn.className = PDP_LIGHT_ARROW_BTN + " " + PDP_LIGHT_ARROW_BTN + "--next";
      nextBtn.setAttribute("aria-label", "Next slide");
      nextBtn.innerHTML = PDP_LIGHT_ARROW_NEXT;

      prevBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var embla = carousel._carousel;
        if (!embla || !embla.canScrollPrev()) return;
        markUserInteracted(carousel);
        embla.scrollPrev();
      });

      nextBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var embla = carousel._carousel;
        if (!embla || !embla.canScrollNext()) return;
        markUserInteracted(carousel);
        embla.scrollNext();
      });

      wrap.appendChild(prevBtn);
      wrap.appendChild(nextBtn);
      block.appendChild(wrap);
    }

    return wrap;
  }

  function syncPdpLightArrows(carousel) {
    if (!isPdpLayout() || isMobile()) {
      removePdpLightArrows(carousel);
      return;
    }

    var wrap = ensurePdpLightArrows(carousel);
    var block = getMoastBlock(carousel);
    var root = carousel && carousel.shadowRoot;
    if (!wrap || !block || !root) return;

    var media =
      root.querySelector(".carousel--cards") ||
      root.querySelector(".carousel") ||
      root.querySelector("#carousel-slides") ||
      root.querySelector(".slides");

    if (media) {
      var blockRect = block.getBoundingClientRect();
      var mediaRect = media.getBoundingClientRect();
      var top = mediaRect.top - blockRect.top + mediaRect.height / 2;
      wrap.style.top = top + "px";
    }

    var embla = carousel._carousel;
    if (!embla) return;

    var prev = wrap.querySelector("." + PDP_LIGHT_ARROW_BTN + "--prev");
    var next = wrap.querySelector("." + PDP_LIGHT_ARROW_BTN + "--next");

    if (prev) {
      var canPrev = embla.canScrollPrev();
      prev.classList.toggle("is-disabled", !canPrev);
      prev.setAttribute("aria-disabled", canPrev ? "false" : "true");
    }
    if (next) {
      var canNext = embla.canScrollNext();
      next.classList.toggle("is-disabled", !canNext);
      next.setAttribute("aria-disabled", canNext ? "false" : "true");
    }
  }

  function updatePdpArrows(carousel, root) {
    if (!isPdpLayout() || isMobile()) return;
    syncPdpLightArrows(carousel);
    if (!root) return;
    var embla = carousel._carousel;
    if (!embla) return;

    var prev = root.querySelector(".carousel__prev, button.carousel__prev");
    var next = root.querySelector(".carousel__next, button.carousel__next");

    if (prev) {
      var canPrev = embla.canScrollPrev();
      prev.classList.toggle("is-disabled", !canPrev);
      prev.setAttribute("aria-disabled", canPrev ? "false" : "true");
    }
    if (next) {
      var canNext = embla.canScrollNext();
      next.classList.toggle("is-disabled", !canNext);
      next.setAttribute("aria-disabled", canNext ? "false" : "true");
    }
  }

  function renderPdpGuide(carousel, root) {
    if (!root) return;
    if (isMobile()) {
      updatePdpGuideLineFill(carousel, ensurePdpGuideLine(root));
      updatePdpArrows(carousel, root);
      return;
    }
    updatePdpGuideLineFill(carousel, root.querySelector("." + GUIDE_LINE_CLASS));
    updatePdpArrows(carousel, root);
  }

  function renderGuide(carousel, guide) {
    if (isPdpLayout()) {
      renderPdpGuide(carousel, carousel.shadowRoot);
      return;
    }
    if (!guide) return;

    var count = getSnapCount(carousel);
    if (count <= 1) {
      guide.innerHTML = "";
      guide.style.display = "none";
      return;
    }

    guide.style.display = "flex";
    var selected = getSelectedIndex(carousel);
    var buttons = guide.querySelectorAll("button");

    if (buttons.length !== count) {
      guide.innerHTML = "";
      for (var i = 0; i < count; i++) {
        (function (index) {
          var btn = document.createElement("button");
          btn.type = "button";
          btn.setAttribute("aria-label", "Go to slide group " + (index + 1));
          btn.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            scrollToIndex(carousel, index);
          });
          guide.appendChild(btn);
        })(i);
      }
      buttons = guide.querySelectorAll("button");
    }

    for (var j = 0; j < buttons.length; j++) {
      if (j === selected) {
        buttons[j].classList.add("is-active");
        buttons[j].setAttribute("aria-current", "true");
      } else {
        buttons[j].classList.remove("is-active");
        buttons[j].removeAttribute("aria-current");
      }
    }
  }

  function bindEmblaEvents(carousel) {
    var embla = carousel._carousel;
    if (!embla || carousel.__moastGuideBound) return;
    carousel.__moastGuideBound = true;

    var sync = function () {
      var root = carousel.shadowRoot;
      if (!root) return;
      injectShadowCss(root);
      if (isPdpLayout()) {
        renderPdpGuide(carousel, root);
        syncPdpLightArrows(carousel);
      } else {
        renderGuide(carousel, ensureGuideBar(carousel, root));
      }
    };

    if (typeof embla.on === "function") {
      embla.on("select", sync);
      embla.on("reInit", sync);
      embla.on("settle", sync);
      if (isPdpLayout() && isMobile()) {
        embla.on("scroll", sync);
      }
      embla.on("pointerDown", function () {
        markUserInteracted(carousel);
      });
    }

    // 首屏强制从第 1 张开始
    ensureLeftStart(carousel);
    scrollToFirst(carousel, true);
    setTimeout(function () {
      if (!carousel.__moastUserInteracted) scrollToFirst(carousel, false);
    }, 80);
    setTimeout(function () {
      if (!carousel.__moastUserInteracted) scrollToFirst(carousel, false);
    }, 300);

    sync();
  }

  function patchCarousel(carousel, options) {
    if (!carousel || patching) return false;
    var root = carousel.shadowRoot;
    if (!root) return false;
    var opts = options || {};

    patching = true;
    try {
      injectHostCss();
      bindEarlyInteractionGuard(carousel);
      ensureLeftStart(carousel);
      injectShadowCss(root);
      clearSlidesPadding(root);
      patchPauseButtons(root);
      if (opts.updateSize !== false) {
        updateSlideSize(carousel, !!opts.forceReinit);
      }
      bindEmblaEvents(carousel);
      if (isPdpLayout()) {
        renderPdpGuide(carousel, root);
        syncPdpLightArrows(carousel);
      } else {
        renderGuide(carousel, ensureGuideBar(carousel, root));
        removePdpLightArrows(carousel);
      }
    } finally {
      patching = false;
    }

    if (!boundCarousels.has(carousel)) {
      boundCarousels.add(carousel);
      new MutationObserver(function (mutations) {
        if (patching) return;
        if (isSelfManagedMutation(mutations)) return;
        clearTimeout(mutationTimer);
        mutationTimer = setTimeout(function () {
          if (patching) return;
          patchCarousel(carousel, { updateSize: false });
          if (typeof window.__moastQuickShopResync === "function") {
            window.__moastQuickShopResync();
          }
        }, 50);
      }).observe(root, { childList: true, subtree: true });
    }

    if (typeof window.__moastQuickShopResync === "function") {
      window.__moastQuickShopResync();
    }

    return !!carousel._carousel;
  }

  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var carousel = getCarousel();
      if (!carousel) return;
      injectHostCss();
      var root = carousel.shadowRoot;
      if (root) injectShadowCss(root);
      carousel.__moastUserInteracted = false;
      patchCarousel(carousel, { updateSize: true, forceReinit: true });
    }, 120);
  }

  function init() {
    var carousel = getCarousel();
    if (!carousel) return false;
    return patchCarousel(carousel);
  }

  function waitAndInit() {
    var started = false;
    var blockObserver = null;

    var start = function () {
      if (started) return true;
      if (!init()) return false;
      started = true;
      window.addEventListener("resize", onResize);
      if (blockObserver) {
        try {
          blockObserver.disconnect();
        } catch (err) {
          /* ignore */
        }
        blockObserver = null;
      }
      return true;
    };

    if (start()) return;

    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (start() || attempts >= 80) clearInterval(timer);
    }, 250);

    var block =
      document.querySelector('.shopify-app-block[id*="moast"]') ||
      document.querySelector("moast-carousel")?.parentElement;
    if (block) {
      blockObserver = new MutationObserver(function () {
        if (start()) clearInterval(timer);
      });
      blockObserver.observe(block, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", waitAndInit);
  } else {
    waitAndInit();
  }

  window.MoastLayoutDebug = function () {
    var carousel = getCarousel();
    return {
      carousel: carousel,
      alignment: carousel && (carousel.alignment || carousel.getAttribute("alignment")),
      hasShadow: !!(carousel && carousel.shadowRoot),
      hasEmbla: !!(carousel && carousel._carousel),
      slideSize:
        carousel &&
        getComputedStyle(carousel).getPropertyValue("--moast-theme-slide-size"),
      visible: getVisibleCount(),
      snaps: carousel ? getSnapCount(carousel) : 0,
      selected: carousel ? getSelectedIndex(carousel) : 0,
      userInteracted: !!(carousel && carousel.__moastUserInteracted),
      layoutMode: getLayoutMode(),
    };
  };
})();
